import { PDFDownloadLink } from "@react-pdf/renderer";
import { useEffect, useRef, useState } from "react";
import { QuotePDF } from "./quotationPDF/QuotePDF";
import { QuotePDFSummary } from "./quotationPDF/QuotePDFSummary";

export const QuotationPrint = ({ values,currencyDetail,distributorList, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const printMenuRef = useRef(null);

    const HandleOpenPDFSummary = (item) => {
        const url = `/pdf-summary?id=${item?.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
      };
      
    
      const HandleOpenPDFDetail = (item) => {
        const url = `/pdf-detail?id=${item?.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (printMenuRef.current && !printMenuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === "Escape") setIsOpen(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscape);
        };
    }, []);

    return (
        <>
            <div className="text-right">
                <div className={`quotation-print-menu ${isOpen ? "open" : ""}`} ref={printMenuRef}>
                    <button
                        className="btn add-new-btn"
                        type="button"
                        aria-haspopup="menu"
                        aria-expanded={isOpen}
                        onClick={() => {
                            if (!disabled) setIsOpen((prev) => !prev);
                        }}
                        disabled={disabled}
                    >
                        Print <i className="fas fa-chevron-down ml-2"></i>
                    </button>
                    <div
                        className="quotation-print-dropdown"
                        role="menu"
                    >
                        <ul>
                            <li>
                                <button
                                    type="button"
                                    role="menuitem"
                                    disabled={disabled}
                                    onClick={() => {
                                        setIsOpen(false);
                                        HandleOpenPDFSummary(values);
                                    }}
                                >
                                    Preview Summary
                                </button>
                                {/* <PDFDownloadLink
                                    document={<QuotePDFSummary distributorList={distributorList} values={values} currencyDetail={currencyDetail} />}
                                    fileName={`${values?.quoteReference}-Summary.pdf`}
                                >
                                    {({ blob, url, loading, error }) =>
                                        loading ? (
                                            <button disabled>Generating PDF...</button>
                                        ) : error ? (
                                            <span>Error generating PDF</span>
                                        ) : (
                                            <a href={url} target="_blank" rel="noopener noreferrer">
                                                Preview Summary
                                            </a>
                                        )
                                    }
                                </PDFDownloadLink> */}
                            </li>
                            <li>
                                <button
                                    type="button"
                                    role="menuitem"
                                    disabled={disabled}
                                    onClick={() => {
                                        setIsOpen(false);
                                        HandleOpenPDFDetail(values);
                                    }}
                                >
                                    Preview Detail
                                </button>
                                {/* <PDFDownloadLink
                                    document={<QuotePDF distributorList={distributorList} values={values} currencyDetail={currencyDetail} />}
                                    fileName={`${values?.quoteReference}-Detail.pdf`}
                                >
                                    {({ blob, url, loading, error }) =>
                                        loading ? (
                                            <button disabled>Generating PDF...</button>
                                        ) : error ? (
                                            <span>Error generating PDF</span>
                                        ) : (
                                            <a href={url} target="_blank" rel="noopener noreferrer">
                                                Preview Detail
                                            </a>
                                        )
                                    }
                                </PDFDownloadLink> */}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};
